import RewardAddressIcon from '@/assets/img/reward_address@2x.png';
import Button from '@/components/Button';
import { Tit, H2 } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithoutTitle from '@/layouts/LayoutWithoutTitle';
import { FormContainer } from '@/page-blocks/auth/AuthCommon';
import { SectionTop } from '@/page-blocks/mypage/MypageCommon';
import { PageProps, navigate } from 'gatsby';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
// import styled from 'styled-components';

const RewardAddressForm: FC<PageProps> = observer(({ location }) => (
  <LayoutWithoutTitle location={location} title="발송 현황" hideGnb hideMargin>
    <FormContainer
      css={`
        text-align: center;
      `}
    >
      <SectionTop className="by-sub-main-layout">
        <img
          src={RewardAddressIcon}
          alt="하트 말풍선"
          css={`
            width: 123px;
            ${breakpoint(640)} {
              width: 80px;
            }
          `}
        />
        <H2
          css={`
            margin: 40px 0 35px;
            line-height: 1.56;
            ${breakpoint(640)} {
              margin: 20px 0 16px;
            }
          `}
        >
          <span
            css={`
              color: #1cabe2;
            `}
          >
            후원자님
          </span>
          , 유니세프 홈페이지 로그인 후 <br />
          <span
            css={`
              color: #1cabe2;
            `}
          >
            굿즈 수령 주소를 입력
          </span>
          해 주세요.
        </H2>
        <Tit size="s4-1" weight="normal">
          주소지 입력은 <strong>로그인 또는 회원가입 후</strong>에 가능합니다.
        </Tit>
        <Button
          full
          css={`
            margin-top: 72px;
            ${breakpoint(768)} {
              margin-top: 64px !important;
            }
          `}
          onClick={() => navigate(`/mypage/reward-list`)}
        >
          주소 입력하러 가기
        </Button>
      </SectionTop>
    </FormContainer>
  </LayoutWithoutTitle>
));

export default RewardAddressForm;
